module.exports = __webpack_public_path__ + "img/altezza-logo.0ab669fb.svg";